import { ShopfloorLayoutSpecNode } from './shopfloor-layout-spec-node'
import { TransportCost } from './transport-cost'

export class GroupedEdgeTarget {
  constructor(
    public id: string,
    public node: ShopfloorLayoutSpecNode,
    public transportCost: TransportCost
  ) {}
}
